import { useCallback } from 'react';
import { useLivePriceSender } from 'global/Datafeed/UseLivePrice/useLivePriceSender';
import { useLivePriceReceiver } from 'global/Datafeed/UseLivePrice/useLivePriceReceiver';
import useTradingAccount from 'hooks/useTradingAccount';
import {
  UseLivePriceRes,
  UseLivePriceKey,
} from 'global/Datafeed/UseLivePrice/useLivePrice.types';
import { LivePriceSymbolsKeyEnum } from 'global/Datafeed/UseLivePrice/liveprice.store.types';

type LivePriceKey<T extends UseLivePriceKey = UseLivePriceKey> = Partial<
  Record<T, LivePriceSymbolsKeyEnum>
>;

const StateKey: LivePriceKey<UseLivePriceKey> = {
  trade_page: LivePriceSymbolsKeyEnum.TRADE_PAGE,
  portfolio_detail: LivePriceSymbolsKeyEnum.PORTFOLIO_DETAIL,
  orderlist_detail: LivePriceSymbolsKeyEnum.ORDERLIST_DETAIL,
};

interface LivePriceConfig {
  symbol: string | string[];
  page: UseLivePriceKey;
}

const useLivePriceUpdater = (
  config: LivePriceConfig,
  updateFunction: (message: UseLivePriceRes) => void,
) => {
  const { isRealTrading } = useTradingAccount();

  const { symbol, page } = config;

  const symbols = Array.isArray(symbol) ? symbol : [symbol];

  useLivePriceSender(StateKey[page], symbols);

  const livePriceOnMessage = useCallback(
    (message: UseLivePriceRes) => {
      if (!isRealTrading) return;

      const isSymbolMatch = Array.isArray(symbol)
        ? symbol.includes(message.stockCode)
        : message.stockCode === symbol;

      if (!isSymbolMatch) return;

      updateFunction(message);
    },
    [symbol, isRealTrading, updateFunction],
  );

  useLivePriceReceiver(
    symbols,
    page,
    livePriceOnMessage,
  );
};

export default useLivePriceUpdater;
